import { compose, flattenProp, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addIntlProps, addProps } from 'utils/recompose';
import messages from './messages';
import { designPackageKeys, subsection } from 'reducers/cart/selectors';
import { theme, mini } from 'reducers/dashboard/selectors';
import { templateIdsForSubsection } from 'reducers/inCartTemplates/selectors';
import { selectAllTemplatesSerieBodyStyle } from 'reducers/cart/actions';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  subsection,
  templateIdsForSubsection,
  designPackageKeys,
  theme,
  mini,
});

export const selectAll = ({
  unlockedTemplateIds,
  selectAllTemplatesSerieBodyStyle,
}) => () => selectAllTemplatesSerieBodyStyle(unlockedTemplateIds);

export const keyToLabelMapping = ({
  exteriorString,
  wheelString,
  interiorString,
  trimString,
  colorLineString,
  capsString,
}) => ({
  paintOption: exteriorString,
  wheelOption: wheelString,
  trimOption: trimString,
  interiorOption: interiorString,
  colorLineOption: colorLineString,
  roofAndMirrorCapOption: capsString,
});

export const columnLabels = ({ designPackageKeys, keyToLabelMapping }) =>
  designPackageKeys.map(designKey => keyToLabelMapping[designKey]);

export const selectAllStyle = ({ theme }) => ({ color: theme.palette.primary });

export default compose(
  connect(mapStateToProps, { selectAllTemplatesSerieBodyStyle }),
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'modelString',
      'optionClusterString',
      'exteriorString',
      'wheelString',
      'interiorString',
      'trimString',
      'totalPriceString',
      'quantityString',
      'priorityString',
      'selectAllString',
      'colorLineString',
      'capsString',
    ],
  }),
  flattenProp('templateIdsForSubsection'),
  withHandlers({ selectAll }),
  addProps({ keyToLabelMapping, selectAllStyle }),
  addProps({ columnLabels }),
);
